import { Image } from "react-bootstrap"

function WorkspaceLogoThumbnail({workspace}){
    const handleClick = () => {
        window.location.href = `/organizations/${workspace.organization_id}/workspaces/${workspace.id}/list`
    }

    if(!workspace?.logo){
        return null;
    }

    return(
        <div 
            className="d-flex align-items-center cursor-pointer" 
            onClick={handleClick}
        >
            <Image 
                src={workspace.logo.thumb_url} 
                className={'mr-lg-2'} 
                style={{ maxWidth: 40, maxHeight: 40, float: "left" }} 
                rounded
            />
        </div>
    )
}

export default WorkspaceLogoThumbnail